import {useState} from 'react';
import { useForm } from "react-hook-form";
import Button from "../Button";
import Input from "../inputs/Input";

const Form = () => {
    const formValues = {
        firstName:"",
        lastName:"",
        email:"",
        phone:"",
        jobTitle:"",
        companySize:"",
        problem:""
    };

    const [isLoading,setIsLoading]  = useState(false)
    const {register,handleSubmit,reset,formState:{errors}} = useForm({
        defaultValues:formValues
    })

    const submitHandler = (data) => {
        console.log(data)
        reset(formValues);
    }


    return (
        <div className="row">
            <div className="col-12 col-lg-6 mb-3">
                <div className="form-group">
                    <Input 
                        label={'First Name'}
                        id={'firstName'}   
                        name={'firstName'} 
                        placeholder='First Name'
                        disabled={isLoading}
                        register={register}
                        errors={errors}
                        required                                       
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6 mb-3">
                <div className="form-group">
                    <Input 
                        label={'Last Name'}
                        id={'lastName'} 
                        name={'lastName'}  
                        placeholder='Last Name' 
                        disabled={isLoading}
                        register={register}
                        errors={errors}
                        required                                             
                    />
                </div>
            </div>
            <div className="col-12 mb-3">
                <div className="form-group">
                    <Input 
                        label={'Email'}
                        type={'email'}
                        id={'email'} 
                        name={'email'}   
                        placeholder='Email'
                        disabled={isLoading}
                        register={register}
                        errors={errors}
                        required                                               
                    />                                           
                </div>									
            </div>
            <div className="col-12 col-lg-6 mb-3">
                <div className="form-group">
                    <Input 
                        label={'Phone'}                        
                        id={'phone'}   
                        name={'phone'}  
                        placeholder='Phone'   
                        disabled={isLoading}
                        register={register}
                        errors={errors}
                        required                                           
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6 mb-3">
                <div className="form-group">
                    <Input 
                        label={'Job Title'}
                        id={'jobTitle'}  
                        name={'jobTitle'}  
                        placeholder='Job Title' 
                        disabled={isLoading}
                        register={register}
                        errors={errors}
                        required                                              
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6 mb-3">
                <div className="form-group">
                    <Input 
                        label={'Company Size'}
                        id={'companySize'} 
                        name={'companySize'}  
                        placeholder='Company Size' 
                        disabled={isLoading}
                        register={register}
                        errors={errors}
                        required                                               
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6 mb-3">
                <div className="form-group">
                    <Input 
                        label={'Problem'}
                        type='text'
                        id={'problem'} 
                        name={'problem'}  
                        placeholder='Problem' 
                        disabled={isLoading}
                        register={register}
                        errors={errors}
                        required                                               
                    />
                </div>
            </div>                                    
            <div className="col-12 mt-3 mt-lg-4">	
                <div className="d-block d-md-flex d-lg-flex align-items-center">
                    <div className="mb-3 mb-md-0">
                        <Button 
                            icon={''}
                            className='btn btn-dark'
                            title={'Submit'}
                            onClick={handleSubmit(submitHandler)}
                        />                                                    
                    </div>                                              																				
                </div>								
            </div>
        </div>
    );
};

export default Form;